import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment-timezone';
import envKeys from '../environment';
import { getLsUserInfo, setLsUserInfo } from '@util/common/util';

export const DEFAULT_LANGUAGE = 'ko';
const USER_INFO_REDUCER = 'userInfo';
export const ACTION_TYPE_LOGOUT = `${USER_INFO_REDUCER}/logOut`;

const keepLanguage = () => {
    if (localStorage.getItem(envKeys.userInfoKey)) {
        const { userInfo } = getLsUserInfo();
        return userInfo && userInfo.lang ? userInfo.lang : DEFAULT_LANGUAGE;
    }
    return DEFAULT_LANGUAGE;
};

const ROLE_ADMIN = 'A';
const ROLE_USER = 'U';

const initialState = {
    modal: {
        modalOauthStatusOpen: false,
    },
    userInfo: {},
    oAuthInfo: {},
    lang: keepLanguage(),
    licenseStatus: {},
};

const { actions, reducer } = createSlice({
    name: USER_INFO_REDUCER,
    initialState,
    reducers: {
        // 초기 로그인시 유저 정보 저장
        setUserInfo: (state, { payload }) => {
            const { responseData, requestData } = payload;
            let userInfo = {};
            if (responseData && responseData.access_token) {
                userInfo = { userId: requestData.userID, ...responseData };
            }
            state.userInfo = userInfo;
            setLsUserInfo(userInfo);
        },
        // refresh token 받아온 후 유저 정보 저장
        setOauthInfo: (state, action) => {
            const oAuthInfo = action.payload;
            if (oAuthInfo && oAuthInfo.access_token) {
                const userInfo = getLsUserInfo();
                state.oAuthInfo = oAuthInfo;
                setLsUserInfo({ ...userInfo, oAuthInfo });
            }
        },
        setOauthStatusModal: (state, action) => {
            state.modal.modalOauthStatusOpen = action.payload;
        },
        setLanguage: (state, action) => {
            const lang = action.payload;
            state.lang = lang;

            const userInfo = getLsUserInfo();
            if (userInfo.userInfo) {
                userInfo.userInfo.lang = lang;
            } else {
                userInfo.userInfo = { lang };
            }
            setLsUserInfo(userInfo);
        },
        setAdditionalInfo: (state, action) => {
            const { serviceCode } = envKeys;
            const additionalInfo = action.payload;

            if (additionalInfo.companyInfo && additionalInfo.companyInfo.timeZone) {
                moment.tz.setDefault(additionalInfo.companyInfo.timeZone);
            }

            if (additionalInfo.serviceProductRoleList && Array.isArray(additionalInfo.serviceProductRoleList)) {
                additionalInfo.settingAuth = !!additionalInfo.serviceProductRoleList.find(
                    role => role.serviceCode === serviceCode && role.serviceRole === ROLE_ADMIN,
                );
            }

            let lsUserInfo = getLsUserInfo();
            state.userInfo = { ...state.userInfo, ...additionalInfo };
            lsUserInfo = { ...lsUserInfo, userInfo: state.userInfo };
            setLsUserInfo(lsUserInfo);
        },
        logOut: (state, action) => {
            const { userInfoKey } = envKeys;
            state.userInfo = {};
            state.oAuthInfo = {};
            state.licenseStatus = {};
            state.modal.modalOauthStatusOpen = false;
            localStorage.removeItem(userInfoKey);
        },
        setLicenseStatus: (state, action) => {
            state.licenseStatus = action.payload;
        },
    },
});

export const {
    setUserInfo,
    setOauthInfo,
    setOauthStatusModal,
    setLanguage,
    setAdditionalInfo,
    logOut,
    setLicenseStatus,
} = actions;
export default reducer;
